mainApp.component('routingTable', {
    templateUrl: '/public/components/routing-table.component.html',
    controller: function($state, $timeout, $scope, DevicesService, $filter, IntervalService) {
        const ctrl = this;

        ctrl.$onInit = function() {
            ctrl.showLoader();

            ctrl.collapsedState = {};
            ctrl.showAllRoutes = true;

            ctrl.automaticPopSelection = {
                id: -1,
                name: 'Automatic',
                usages: 'max'
            };
            ctrl.selectedPop = ctrl.automaticPopSelection;

            ctrl.icons = DevicesService.getDevicesIcons();
            ctrl.fetchFirstData();

            // We want to hide the loader after 30 seconds even if routing table is empty
            ctrl.loaderTimeout = $timeout(function() {
                ctrl.loaderTimeout = undefined;
                ctrl.hideLoader(true);
            }, 30000);
        }

        ctrl.$onDestroy = function() {
            if (ctrl.loaderTimeout) {
                $timeout.cancel(ctrl.loaderTimeout)
            }

            if (ctrl.firstFetchInterval) {
                IntervalService.cancelDynamicInterval($scope.$id, 'routingTableFirstFetch');
            } else {
                IntervalService.cancelDynamicInterval($scope.$id, 'routingTableFetch');
            }
        }

        ctrl.showLoader = function() {
			$('#loading-wrapper').css({
				display: 'block',
				opacity: 1,
			});
		}

		ctrl.hideLoader = function(fadeOut) {
			if (fadeOut) {
				$('#loading-wrapper').fadeOut();
			} else {
				$('#loading-wrapper').css('display', 'none');
			}
		}

        $scope.$on('$toggleClicked', function (event, id, checked) {
            ctrl.showAllRoutes = !ctrl.showAllRoutes;
            ctrl.tableModified = new Date().getTime();
        });

        ctrl.fetchFirstData = () => {
            ctrl.firstFetchInterval = true;
            IntervalService.dynamicInterval(fetchFirstDataInterval, $scope.$id, 'routingTableFirstFetch', false);
        }

        let fetchFirstDataInterval = () => {
            ctrl.fetchData();
            if (ctrl.currentData && ctrl.currentData.entityRoutesData) {

                IntervalService.cancelDynamicInterval($scope.$id, 'routingTableFirstFetch');
                ctrl.firstFetchInterval = undefined;

                ctrl.startIntervalFetch();
                ctrl.hideLoader(true);
            }
        }

        ctrl.startIntervalFetch = () => {
            IntervalService.dynamicInterval(ctrl.fetchData, $scope.$id, 'routingTableFetch', false);
            ctrl.fetchInterval = true;
        }

        ctrl.stopIntervalFetch = function() {
            IntervalService.cancelDynamicInterval($scope.$id, 'routingTableFetch');
            ctrl.fetchInterval = undefined;
        }

        ctrl.isPaused = function() {
            return angular.isDefined(ctrl.fetchInterval);
        }

        ctrl.toggleAllRoutes = function() {
            ctrl.showAllRoutes = !ctrl.showAllRoutes;
            ctrl.tableModified = new Date().getTime();
        }

        ctrl.shouldPresentPopSelection = function() {
            return isSystemLogin && ctrl.pops;
        }

        ctrl.popSelected = function() {
            ctrl.currentData = null;
            ctrl.stopIntervalFetch();
            ctrl.fetchFirstData();
        }

        ctrl.fetchData = function() {
            store.fetch({
                path: 'getTransientRealTimeData/routing?accountId=' + $state.params.accountId + '&popId=' + ctrl.selectedPop.id,
                success: function(data) {
                    // the second part of the condition is to reduce (not fully fixes it) edge cases when received response is
                    // not suitable to the selected pop (can happen if pop selected while front-end was waiting for response)
                    if (data && (data.popId === ctrl.selectedPop.id || ctrl.selectedPop.id === -1)) {
                        var $notificationsEl = $('.ngn');
                        if (data.status && data.status === 'ERROR') {
                            if ($notificationsEl.css('display') !== 'block') {
                                $scope.$root.showNotification('error', data.notifications[0].message, data.notifications[0].message, true, true);
                            }
                        } else {
                            if ($notificationsEl.css('display') == 'block') {
                                $scope.$root.hideNotification();
                            }
                            ctrl.currentData = data;
                            ctrl.tableModified = new Date().getTime();

                            ctrl.pops = _.map(data.popIdToName, function(name, id) {
                                return {
                                    id: parseInt(id, 10),
                                    name: name,
                                    usages: data.popIdToUsagesCount[id]
                                };
                            });
                            ctrl.pops.push(ctrl.automaticPopSelection);
                        }
                    }
                    $scope.$digest();
                }
            });
        }

        ctrl.tableConfig = {
            dataURL: function() {
                return null;
            },
            parseData: function() {
                let result = [];
                let entityData = (ctrl.currentData && ctrl.currentData.entityRoutesData) || [];
                entityData.forEach(entity => {
                    entity.routes.forEach(route => {
                        if (!ctrl.showAllRoutes && !route.isActive)
                            return;

                        result.push({
                            id: entity.id,
                            isActive: route.isActive,
                            deviceType: typeof route.isPrimaryDevice !== 'undefined' ? (route.isPrimaryDevice ? 'Primary Socket' : 'Secondary Socket') : '',

                            name: entity.name,
                            type: entity.type,
                            connType: entity.connType,
                            isIPSecConnType: entity.isIPSecConnType,
                            country: entity.country,
                            ip: route.ip,
                            pop: route.pop,
                            routeType: route.type,
                            routeLastUpdate: route.routeLastUpdate,

                            metricSummary: (route.tunnelMetric || route.tunnelMetric === 0 ? route.tunnelMetric : '?') + ', ' + (route.weight || route.weight === 0 ? route.weight : '?') + ', ' + (route.asLength || route.asLength === 0 ? route.asLength : '?') + ', ' + (route.metricDiscriminatory || route.metricDiscriminatory === 0 ? route.metricDiscriminatory : '?') + ', ' + $filter('durationHumanize')(route.metricLastUpdate * 1000),
                            tunnelMetric: route.tunnelMetric,
                            asLength: route.asLength,
                            weight: route.weight,
                            metricDiscriminatory: route.metricDiscriminatory,
                            metricLastUpdate: route.metricLastUpdate,

                            isAsPathSupportedInSocket: route.isAsPathSupportedInSocket,
                            hasBGP: route.hasBGP,
                            pathSummary: '',
                            nextHop: route.nextHop,
                            origin: route.origin,
                            asPath: route.asPath,
                            communities: route.communities,
                        });
                    });
                });

                result.sort(function(r1, r2) {
                    if (r1.name !== r2.name)
                        return r1.name > r2.name ? -1 : 1;
                    if (r1.isActive !== r2.isActive)
                        return r1.isActive ? -1 : 1;
                    return 0;
                });

                return result;
            },
            getSiteTypeImageUrl: function(item) {
                if (item.type === 'user')
                    return '/public/images/entities/user.png';
                return ctrl.icons['site' + item.type] || '';
            },
            navigateToConfiguration: function(item) {
                if (item.type === 'user') {
                    $state.go('app.logins', {
                    	id: item.id,
                    });
                } else {
                    $state.go('app.sites', {
                        id: item.id,
                    });
                }
            },
            isCollapsed: function(item, category) {
                if (!ctrl.collapsedState[category + '-' + item.type + '-' + item.id + '-' + item.ip])
                    return true;
                return false;
            },
            changeCollapsedState: function(item, collapsed, category) {
                if (collapsed) {
                    ctrl.collapsedState[category + '-' + item.type + '-' + item.id + '-' + item.ip] = true;
                } else {
                    ctrl.collapsedState[category + '-' + item.type + '-' + item.id + '-' + item.ip] = false;
                }
            },
            getCustomRowClass: function(item) {
                if (!item.isActive)
                    return 'non-active-route';
                return '';
            },
            clientSidePaging: true,
            clientSideSearch: true,
            clientSideSort: true,
            titleSearch: 'IP/Name',
            searchPredicate: function(item, valueToSearch) {
                const ip4ToInt = ip => ip.split('.').reduce((int, oct) => (int << 8) + parseInt(oct, 10), 0) >>> 0;

                const isIp4InCidr = (ip, cidr) => {
                    const [range, bits = 32] = cidr.split('/');
                    const mask = ~(2 ** (32 - bits) - 1);
                    return (ip4ToInt(ip) & mask) === (ip4ToInt(range) & mask);
                };

                return item.name.toLowerCase().includes(valueToSearch) || item.ip.includes(valueToSearch) || isIp4InCidr(valueToSearch, item.ip);
            },
            fields: [{
                label: 'Name',
                template:  `<div>
                                <div style="display:inline-block; vertical-align:middle;">
                                    <img src="" ng-src="{{tableConfig.getSiteTypeImageUrl(item)}}" class="site-type-icon"/>
                                    <span class="flag-icon flag-icon-{{item.country.code | lowercase}}"></span>
                                </div>&nbsp
                                <div style="display:inline-block; vertical-align:middle;">
                                    <span><b>{{item.name}}</b></span><br/>
                                    <span>{{item.connType}}{{item.deviceType ? ': ' + item.deviceType : ''}}</span>
                                </div>
                            </div>
                `
            }, {
                label: 'IP/Subnet',
                template: `<span>{{item.ip}}</span>`
            }, {
                label: 'Next Hop',
                template: ` <div ng-show="!item.isAsPathSupportedInSocket && !item.isIPSecConnType" class="more-info cato-tooltip" data-title='This feature is only supported for Socket version 5.2.2893 and higher. Please contact Support to upgrade to the newest version.'>
                                <span>N/A</span>
                            </div>
                            <span ng-show="(item.isAsPathSupportedInSocket || item.isIPSecConnType) && !item.nextHop && item.routeType === 'STATIC'">Directly connected</span>
                            <div ng-show="item.isIPSecConnType && !!item.nextHop && item.routeType === 'DYNAMIC'" class="more-info cato-tooltip" data-title='Not applicable for IPSec site with dynamic routing.'>
                                <span>N/A</span>
                            </div>
                            <span ng-show="item.isAsPathSupportedInSocket && !item.isIPSecConnType && !!item.nextHop">{{item.nextHop}}</span>
                            <span ng-show="item.isAsPathSupportedInSocket && !item.isIPSecConnType && !item.nextHop && item.routeType === 'DYNAMIC'">N/A</span>
                `
            }, {
                label: 'Routing Type',
                template: `<span>{{item.routeType}}</span>`
            }, {
                label: 'PoP',
                template: `<span>{{item.pop}}</span>`
            }, {
                label: 'Route Last Update',
                template: ` <div class="more-info cato-tooltip" data-title='{{item.routeLastUpdate | secondsToDateTime | timeToMoment}}'>
                                <span>{{item.routeLastUpdate * 1000 | durationHumanize}}</span>
                            </div>`
            }, {
                label: 'Details',
                template:  `<expandable-section label='Metric Information' one-liner='true' summary='{{item.metricSummary}}' on-expand-event='tableConfig.changeCollapsedState(item, true, "metric")' on-collapse-event='tableConfig.changeCollapsedState(item, false, "metric")' initially-collapsed='tableConfig.isCollapsed(item, "metric")'>
                                <span>Tunnel Metric: {{item.tunnelMetric}}</span><br/>
                                <span>Weight: {{item.weight}}</span><br/>
                                <span>AS Length: {{item.asLength}}</span><br/>
                                <span>Metric Discriminatory: {{item.metricDiscriminatory}}</span><br/>
                                <span>Last Update:
                                    <div class="more-info cato-tooltip" data-title='{{item.metricLastUpdate | secondsToDateTime | timeToMoment}}'>
                                        <span>{{item.metricLastUpdate * 1000 | durationHumanize}}</span>
                                    </div>
                                </span><br/>
                            </expandable-section>
                            <expandable-section ng-show='{{item.hasBGP}}' label='Additional BGP Information' one-liner='true' summary='{{item.pathSummary}}' on-expand-event='tableConfig.changeCollapsedState(item, true, "path")' on-collapse-event='tableConfig.changeCollapsedState(item, false, "path")' initially-collapsed='tableConfig.isCollapsed(item, "path")'>
                                <span>AS Path:</span><br/>
                                <ul>
                                    <li ng-repeat="asPath in item.asPath">{{asPath.type}}: {{asPath.list}}</li>
                                </ul>
                                <span>Origin AS: {{item.origin}}</span><br/>
                                <span>Communities: {{item.communities}}</span><br/>
                            </expandable-section>
                `
            }
            , {
                label: 'Settings',
                template: '<svg class="icon icon-config" ng-click="tableConfig.navigateToConfiguration(item)"><use xlink:href="/public/images/icons/main.svg#icon-config"></use></svg>'
            }],
        }
    }
});
